<template>
  <ls-search-form
    @search="onSearch"
    :formList="formList"
    ref="refSearchForm"
  >
    <!-- <global-select
      slot="planNo"
      key="planNo"
      v-decorator="['planNoList']"
      selectType="selectMultipleSearch"
      requestApi="/scp/scpSopPurchasePlanPool/getAllPlanNo"
      :selectItem="{ value: 'realValue', label: 'label' }"
      searchParam="planNo"
    /> -->
    <a-input
      slot="planNo"
      key="planNo"
      v-decorator="['planNoList']"
      allowClear
      placeholder="支持Excel复制批量搜索"
    />
    <global-select
      key="typeKey"
      slot="type"
      selectType="selectSearch"
      v-decorator="['type']"
      :dropdown-match-select-width="false"
      requestApi="/system/lookup/data/list"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
      searchParam="lookupValue"
      :setParams="{ lookupType: 'SCP_DOC_TYPE' }"
    />
    <global-select
      key="developType"
      slot="developType"
      v-decorator="['developType']"
      :value.sync="queryParams.developType"
      :selectData="developTypeList"
      selectType="selectFilter"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
    />
    <global-select
      key="applicantUserNo"
      slot="applicantUserNo"
      v-decorator="['applicantUserNo']"
      :value.sync="queryParams.applicantUserNo"
      selectType="selectSearch"
      requestApi="/mes/mesDiscreteJobs/founderBox"
      :selectItem="{ value: 'realValue', label: 'label' }"
      searchParam="jobCode"
    />
    <global-select
      key="supplierCode"
      slot="supplierCode"
      v-decorator="['supplierCode']"
      selectType="selectSearch"
      requestApi="/mdm/mdmOrgSupplier/supplierNameList"
      :selectItem="{ value: 'label', label: 'realValue' }"
      searchParam="supplierName"
    />
    <a-select v-decorator="['statusList']" allowClear slot="statusList" mode="multiple" key="statusList">
      <a-select-option v-for="item in PLAN_STATUS" :value="item.lookupCode" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
    </a-select>
    <global-select
      selectType="selectSearch"
      v-decorator="['projectDept']"
      slot="projectDept"
      key="projectDept"
      :dropdown-match-select-width="false"
      requestApi="/system/lookup/data/likeList"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
      :setParams="{ lookupType: 'SCP_PROJECT_TEAM' }"
      searchParam="lookupValue"
    />
    <!-- <global-select
      key="itemCode"
      slot="itemCode"
      v-decorator="['itemCode']"
      :dropdown-match-select-width="false"
      selectType="selectSearch"
      requestApi="/scp/scpMrpSystemItems/planItemsBox"
      :selectItem="{ value: 'selectedValue', label: 'label', thirdLabel: 'selectedValue' }"
      :setParams="{ organizationCode: 'A001' }"
      searchParam="label"
      sourseField="res"
      :totalNum="9999999999"
    /> -->
    <global-select
      slot="itemCode"
      v-decorator="['itemCode']"
      selectType="selectAssembleSearch"
      :focusGet="true"
      requestApi="/mes/mesDiscreteJobs/assemblyBox"
      :selectItem="{
        value: 'selectedValue', label: 'bringOutDataOne',
        getCustomKeyFunc: (item, index) => item.selectedValue + index,
      }"
      searchParam="itemCode"
      :setParams="{ organizationCode: 'A001' }"
      :dropdown-match-select-width="false"
      :indexInKey="true"
    />
    <a-month-picker
      key="planCycle"
      slot="planCycle"
      v-decorator="['planCycle']"
      valueFormat="YYYY-MM"
      format="YYYY-MM"
      allowClear
      class="full-width"
    />
    <a-select v-decorator="['materialStatus']" allowClear slot="materialStatus" key="materialStatus">
      <a-select-option v-for="item in MATERIAL_STATUS" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
    </a-select>
    <a-select v-decorator="['signStatus']" allowClear slot="signStatus" key="signStatus">
      <a-select-option v-for="item in SIGN_STATUS" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
    </a-select>
    <global-select
      key="createBy"
      slot="createBy"
      v-decorator="['createBy']"
      selectType="selectSearch"
      requestApi="/mes/mesDiscreteJobs/founderBox"
      :selectItem="{ value: 'realValue', label: 'label' }"
      searchParam="jobCode"
    />
    <a-range-picker
      key="auditTime"
      slot="auditTime"
      v-decorator="['auditTime']"
      valueFormat="YYYY-MM-DD"
      allowClear
    />
    <a-range-picker
      key="createTime"
      slot="createTime"
      v-decorator="['createTime']"
      valueFormat="YYYY-MM-DD"
      allowClear
    />
    <a-range-picker
      key="issueTime"
      slot="issueTime"
      v-decorator="['issueTime']"
      valueFormat="YYYY-MM-DD"
      allowClear
    />
    <a-range-picker
      key="estimatedDeliveryDate"
      slot="estimatedDeliveryDate"
      v-decorator="['estimatedDeliveryDate']"
      valueFormat="YYYY-MM-DD"
      allowClear
    />
  </ls-search-form>
</template>

<script>
import isNil from 'lodash/isNil';
// import DressingByScreening from '@/components/DressingByScreening/index'
// import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import moment from 'moment'
import {
  MATERIAL_STATUS,
  SIGN_STATUS,
  PLAN_STATUS
} from '../common'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'SearchForm',
  components: { },
  mixins: [cacheRequest],
  props: {
    activeStateKey: {
      type: Number,
      required: true
    }
  },
  data() {
    this.dateList = [
      'createTime',
      'auditTime',
      'issueTime',
      'estimatedDeliveryDate'
    ];
    return {
      developTypeList: [],
      workshopCodeList: [],
      advanced: true,
      searchList: [],
      queryParams: {}
    }
  },
  computed: {
    MATERIAL_STATUS() {
      return Object.values(MATERIAL_STATUS)
    },
    SIGN_STATUS() {
      return Object.values(SIGN_STATUS)
    },
    PLAN_STATUS() {
      return Object.values(PLAN_STATUS).filter(item => item.lookupCode !== PLAN_STATUS.ALL.lookupCode)
    },
    formList() {
      return [
        {
          label: '计划单号',
          type: 'planNo',
          decorator: ['planNo']
        },
        {
          label: '单据类型',
          type: 'type',
          decorator: ['type']
        },
        {
          label: '申请人',
          type: 'applicantUserNo',
          decorator: ['applicantUserNo']
        },
        {
          label: '供应商',
          type: 'supplierCode'
        },
        {
          label: '单据状态',
          type: 'statusList',
          decorator: ['statusList']
        },
        {
          label: '项目部',
          type: 'projectDept',
          decorator: ['projectDept']
        },
        {
          label: '物料编码',
          type: 'itemCode',
          decorator: ['itemCode']
        },
        {
          label: '计划周期',
          type: 'planCycle',
          decorator: ['planCycle']
        },
        {
          label: '备料状态',
          type: 'materialStatus',
          decorator: ['materialStatus']
        },
        {
          label: '签署状态',
          type: 'signStatus',
          decorator: ['signStatus']
        },
        {
          label: '创建人',
          type: 'createBy',
          decorator: ['createBy']
        },
        {
          label: '创建日期',
          type: 'createTime',
          decorator: ['createTime']
        },
        {
          label: '审核日期',
          type: 'auditTime',
          decorator: ['auditTime']
        },
        {
          label: '发放日期',
          type: 'issueTime',
          decorator: ['issueTime']
        },
        {
          label: '预计交期',
          type: 'estimatedDeliveryDate',
          decorator: ['estimatedDeliveryDate']
        },
        {
          label: '采购空闲数大于',
          type: 'number',
          decorator: ['purchaseFreeQuantity', { initialValue: 0 }]
        },
        {
          label: '已推采购数大于',
          type: 'number',
          decorator: ['pushedPurchaseQuantity', { initialValue: 1 }]
        },
        {
          label: '物料名称',
          type: 'input',
          decorator: ['itemName']
        },
        {
          label: '研发分类标识',
          type: 'developType',
          decorator: ['developType']
        }
      ]
    }
  },
  methods: {
    onSearch(values) {
      for(const filed in values) {
        if(isNil(values[filed]) || values[filed] === '') {
          delete values[filed]
        }
      }
      for(const filed of this.dateList) {
        this.resolveDatePick(values, filed);
      }
      if(values.planNoList) {
        values.planNoList = this.onGetCopyFormExcel(values.planNoList)
      }else {
        delete values.planNoList
      }
      this.$emit("search", values);
    },
    handleSearch() {
      this.$refs.refSearchForm.handleSearch()
    },
    // 公共选择日期
    resolveDatePick(params, field, resolveFields) {
      if (!resolveFields?.length) {
        // const newField = field.charAt(0).toUpperCase() + field.slice(1);
        resolveFields = [field + 'From', field + 'To'];
      }
      const value = params[field];
      if (value && value.length > 0) {
        params[resolveFields[0]] = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
        params[resolveFields[1]] = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
      }
      delete params[field];
    },
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onGetCopyFormExcel(value, listField) {
      const listVal = [];
      if (value) {
        const list = value.split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      return listVal
    }
  },
  created() {
    this.cacheLookupRequest('MDM_ITEM_DEVELOP_TYPE', { lookupType: 'MDM_ITEM_DEVELOP_TYPE', current: 1, pageSize: 999 }, 'developTypeList')
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-form-item-control-wrapper {
  overflow: hidden;
}
.ticket-search-filter{
  min-width: 250px;
}
.full-width {
  width: 100%;
}
/deep/.table-page-search-submitButtons {
  padding: 0;
}
</style>
